import axios, { AxiosRequestConfig } from 'axios'
import firebase from 'firebase/compat/app'
import config from '../config'
import AppEngineService from './AppEngineService'
import AuditService from './AuditService'
import BusinessService from './BusinessService'
import ChatWidgetService from './ChatWidgetService'
import ContactServices from './ContactServices'
import ConversationAiResellingService from './ConversationAIResellingService'
import ConversationsService from './ConversationsService'
import DocumentService from './DocumentService'
import EmailBuilderServices from './EmailBuilderService'
import FunnelsServices from './FunnelServices'
import IntegrationService from './IntegrationsService'
import LocationsService from './LocationsService'
import NotificationService from './NotificationService'
import OauthService from './OauthService'
import OnboardingService from './OnboardingService'
import PaymentServices from './PaymentServices'
import PhoneSystemService from './PhoneSystemService'
import PlatformService from './PlatformService'
import ProductRebillingService from './ProductRebillingService'
import ProductServices from './ProductServices'
import SocialMediaService from './SocialMediaService'
import StatsServices from './StatsServices'
import TemplateService from './TemplateService'
import UrlService from './UrlService'
import UsersService from './UsersService'
import VideosService from './VideosService'
import WebshotService from './WebshotService'

const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28'
  }
}


export const requests = (host?:string, headers?:any) => {
  const baseUrl = host || config.restApiUrl
  const axiosInstance = axios.create(
    {
      baseURL:baseUrl,
      headers: {
        ...getHeader(),
        ...headers
      }
    }
  )

  axiosInstance.interceptors.request.use(async (requestConfig: AxiosRequestConfig) => {
    try {
        requestConfig.headers['token-id'] = await firebase
          .auth()
          .currentUser.getIdToken()
    } catch (e) {
      console.error(`Error in getting the current user token: ${JSON.stringify(e)}`)
    }
    return requestConfig
  })

  return axiosInstance
}

export {
  AppEngineService, AuditService, BusinessService, ChatWidgetService, ContactServices, ConversationAiResellingService, ConversationsService, DocumentService, EmailBuilderServices, FunnelsServices, IntegrationService,
  LocationsService, NotificationService, OauthService, OnboardingService, PaymentServices, PhoneSystemService, PlatformService, ProductRebillingService, ProductServices, SocialMediaService, StatsServices,
  TemplateService, UrlService, UsersService, VideosService, WebshotService
}

